import React from 'react'

const Loading = () => {
  return (
    <i className="fa fa-spin fa-spinner"></i>
  )
}

export default Loading